window.addEventListener("DOMContentLoaded", function () {
  const productEl = document.querySelector(".product-template-container");
  const DOM = {
    productBundleEl: productEl?.querySelector("product-bundle-info"),
    totalPriceEl: productEl?.querySelector(".product-single__price"),
    compareTotalEl: productEl?.querySelector(
      ".product-single__price--compare-at"
    ),
    addCartEl: productEl?.querySelector(".custom_add_to_cart"),
    buyCartEl: productEl?.querySelector(".custom-buy-now-btn"),
    currentEl: null,
    currentType: "cart",
    // 价格状态
    originPrice: 0,
    originComparePrice: 0,
    currentAccessoryPrice: 0,
    currentAccessoryComparePrice: 0,
    currentExtendWarrantyPrice: 0,
    currentExtendWarrantyComparePrice: 0,
    extendWarrantyVariantId: null,
    bottomBar: document.querySelector(".common-tabbar-bottom-purchase-bar"),
    bottomBarColorEl: null,
    bottomBarPriceEl: null,
    bottomBarCompareEl: null,
    bottomBarDiscountEl: null,
    productDiscountEl: productEl?.querySelector(
      ".show-discount .discount-percent"
    ),
    bottomBarIdInput: null,
    bottomAddCartEl: document.querySelector(
      ".common-tabbar-bottom-purchase-bar .add-to-cart-btn-custom"
    ),
    bottomBuyNowEl: document.querySelector(
      ".common-tabbar-bottom-purchase-bar .buy-now-btn-custom"
    ),
  };

  // 底部栏事件
  function bindBottomBarCartEvent() {
    if (!DOM.bottomBar) return;

    if (DOM.bottomBar.dataset.bindCart === "1") return;
    DOM.bottomBar.dataset.bindCart = "1";

    DOM.bottomBar.addEventListener("click", (e) => {
      const btn = e.target.closest(
        ".common-tabbar-bottom-purchase-bar [data-action]"
      );
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      const action = btn.dataset.action;
      if (action === "cart") {
        changeCurrentInfo(btn, "cart");
        bindQtyCartEvent();
      }

      if (action === "buy") {
        changeCurrentInfo(btn, "checkout");
        bindQtyCartEvent();
      }
    });
  }

  function initProductBasePrice() {
    if (!DOM.totalPriceEl) return;

    const salePrice = DOM.totalPriceEl.getAttribute("content") || "0";
    const comparePrice =
      DOM.compareTotalEl?.getAttribute("content") || salePrice;
    DOM.originPrice = salePrice * 100;
    DOM.originComparePrice = comparePrice * 100;
  }

  // 初始化底部栏元素引用
  function initBottomBarRefs() {
    const bar = DOM.bottomBar;
    console.group("🟢 initBottomBarRefs");
    console.groupEnd();
    if (!bar) return;

    bar.classList.add("show");

    DOM.bottomBarColorEl = bar.querySelector(".color-value");
    DOM.bottomBarPriceEl = bar.querySelector(".current-price");
    DOM.bottomBarCompareEl = bar.querySelector(".compare-price");
    DOM.bottomBarDiscountEl = bar.querySelector(".discount-badge");
    DOM.bottomBarIdInput = bar.querySelector('input[name="id"]');
  }

  // 更新底部栏价格显示
  function updateBottomBarDisplay(finalTotal, finalCompareTotal) {
    const bar = DOM.bottomBar;
    if (!bar || !DOM.bottomBarPriceEl) return;

    const formatMoney =
      window.theme?.Currency?.formatMoney ||
      ((price, format) => {
        const amount = (price / 100).toFixed(2);
        return format ? format.replace("{{ amount }}", amount) : `$${amount}`;
      });

    const formattedTotal = formatMoney(
      finalTotal,
      window.theme?.strings?.moneyFormat
    );
    DOM.bottomBarPriceEl.textContent = formattedTotal;

    // compare + discount
    if (finalCompareTotal > finalTotal) {
      if (DOM.bottomBarCompareEl) {
        DOM.bottomBarCompareEl.textContent = formatMoney(
          finalCompareTotal,
          window.theme?.strings?.moneyFormat
        );
        DOM.bottomBarCompareEl.style.display = "inline";
      }

      const dis = Math.round(
        ((finalCompareTotal - finalTotal) * 100) / finalCompareTotal
      );
      if (DOM.bottomBarDiscountEl) {
        DOM.bottomBarDiscountEl.textContent = `Save ${dis}% OFF`;
        DOM.bottomBarDiscountEl.style.display = "inline-block";
        // DOM.productDiscountEl.textContent = `${dis}% OFF`;
      }
      if (DOM.productDiscountEl) {
        DOM.productDiscountEl.textContent = `${dis}%`;
      }
    } else {
      if (DOM.bottomBarCompareEl) DOM.bottomBarCompareEl.style.display = "none";
      if (DOM.bottomBarDiscountEl)
        DOM.bottomBarDiscountEl.style.display = "none";
    }
    DOM.bottomBarPriceEl.setAttribute(
      "aria-label",
      "Sale price: " + formattedTotal + " US dollars"
    );
    DOM.bottomBarCompareEl.setAttribute(
      "aria-label",
      "Original price: " +
        formatMoney(finalCompareTotal, window.theme?.strings?.moneyFormat) +
        " US dollars"
    );
    // id 同步（用统一逻辑里的当前 base variant id）
    const id = DOM.addCartEl?.getAttribute("data-id");
    if (DOM.bottomBarIdInput && id) DOM.bottomBarIdInput.value = id;
  }

  // 更新底部栏变体
  function updateBottomBarColorByVariant(variant) {
    if (!DOM.bottomBarColorEl || !variant) return;
    const color = variant.options?.[0];
    DOM.bottomBarColorEl.textContent =
      color === "Default Title" ? "" : color || "";
  }

  // 监听配件价格变化事件
  function bindAccessoryPriceEvent() {
    document.addEventListener("accessory:priceChange", (e) => {
      console.group("🟡 accessory:priceChange");
      console.groupEnd();

      const { accessoryPrice = 0, accessoryComparePrice = 0 } = e.detail || {};
      DOM.currentAccessoryPrice = accessoryPrice;
      DOM.currentAccessoryComparePrice = accessoryComparePrice;
      updatePriceDisplay();
    });
  }

  function bindExtendWarrantyEvent() {
    document.addEventListener("extendWarranty:change", (e) => {
      const { id = null, unitPrice = 0, unitComparePrice = 0 } = e.detail || {};

      DOM.extendWarrantyVariantId = id;
      DOM.currentExtendWarrantyPrice = +unitPrice || 0;
      DOM.currentExtendWarrantyComparePrice = +unitComparePrice || 0;

      updatePriceDisplay();
    });
  }

  // 更新价格显示
  function updatePriceDisplay() {
    console.group("💰 updatePriceDisplay");

    if (!DOM.totalPriceEl) return;

    const { total: finalTotal, compareTotal: finalCompareTotal } =
      calculateTotalPrice();

    // 格式化价格（使用主题内置方法或默认格式）
    const formatMoney =
      window.theme?.Currency?.formatMoney ||
      ((price, format) => {
        const amount = (price / 100).toFixed(2);
        return format ? format.replace("{{ amount }}", amount) : `$${amount}`;
      });

    const formattedTotal = formatMoney(
      finalTotal,
      window.theme?.strings?.moneyFormat
    );
    const formattedCompare = formatMoney(
      finalCompareTotal,
      window.theme?.strings?.moneyFormat
    );

    // 更新售价
    DOM.totalPriceEl.textContent = formattedTotal;
    if (finalTotal) {
      DOM.totalPriceEl.setAttribute("content", finalTotal / 100);
    }

    if (finalCompareTotal > finalTotal) {
      if (DOM.compareTotalEl) {
        DOM.compareTotalEl.textContent = formattedCompare;
      } else {
        const compareEl = document.createElement("span");
        compareEl.className = "product-single__price--compare-at";
        compareEl.textContent = formattedCompare;
        DOM.totalPriceEl.after(compareEl);
        DOM.compareTotalEl = compareEl;
      }
    } else if (DOM.compareTotalEl) {
      DOM.compareTotalEl.remove();
      DOM.compareTotalEl = null;
    }
    console.groupEnd();

    updateBottomBarDisplay(finalTotal, finalCompareTotal);
  }

  // 处理捆绑产品价格变化
  function handleBundleInfoChange(e) {
    console.group("🟡 bundle:InfoChange");
    console.groupEnd();

    const {
      itemPrice = 0,
      comparePrice = 0,
      id = null,
      color = "",
      bundleIds = [],
    } = e.detail || {};
    DOM.originPrice = itemPrice;
    DOM.originComparePrice = comparePrice;
    changeCartAndBuyId(id, bundleIds);
    if (DOM.bottomBarColorEl) {
      DOM.bottomBarColorEl.textContent = color;
    }

    updatePriceDisplay();
  }

  // 绑定捆绑产品价格事件
  function bindBundlePriceEvent() {
    if (!DOM.productBundleEl) return;

    // 先移除旧事件避免重复绑定
    DOM.productBundleEl.removeEventListener(
      "bundle:InfoChange",
      handleBundleInfoChange
    );
    DOM.productBundleEl.addEventListener(
      "bundle:InfoChange",
      handleBundleInfoChange
    );
  }

  // 计算总价
  function calculateTotalPrice() {
    console.group("🔢 calculateTotalPrice");
    const result = {
      total:
        DOM.originPrice +
        DOM.currentAccessoryPrice +
        DOM.currentExtendWarrantyPrice,
      compareTotal:
        DOM.originComparePrice +
        DOM.currentAccessoryComparePrice +
        DOM.currentExtendWarrantyComparePrice,
    };
    console.groupEnd();
    return result;

    return {
      total:
        DOM.originPrice +
        DOM.currentAccessoryPrice +
        DOM.currentExtendWarrantyPrice,
      compareTotal:
        DOM.originComparePrice +
        DOM.currentAccessoryComparePrice +
        DOM.currentExtendWarrantyComparePrice,
    };
  }

  //更新无库存状态
  function updateVariantAvailable(available) {
    const buyNowButton = DOM.buyCartEl;
    if (buyNowButton) {
      available
        ? buyNowButton.classList.remove("custom-buy-now-btn-sold-out")
        : buyNowButton.classList.add("custom-buy-now-btn-sold-out");
    }
  }

  function syncVariantCheckedState(variant) {
    if (!productEl || !variant) return;
    const options = Array.isArray(variant.options) ? variant.options : [];

    options.forEach((rawValue, optionIndex) => {
      const value = rawValue == null ? "" : String(rawValue);

      const inputs = productEl.querySelectorAll(
        `input.single-option-selector__radio[data-option-index="${optionIndex}"]`
      );
      if (inputs.length) {
        inputs.forEach((input) => {
          const inputValue = input.dataset.optionValue || input.value || "";
          const isMatch = inputValue === value;
          input.checked = isMatch;
          if (isMatch) input.setAttribute("checked", "checked");
          else input.removeAttribute("checked");
        });
      }

      const select = productEl.querySelector(
        `select.single-option-selector__radio[data-option-index="${optionIndex}"]`
      );
      if (select) {
        select.value = value;
        Array.from(select.options).forEach((opt) => {
          if ((opt.value || "") === value) opt.setAttribute("selected", "selected");
          else opt.removeAttribute("selected");
        });
      }
    });
  }

  // 监听主题变体价格变化
  function bindVariantPriceChangeFromTheme() {
    document.addEventListener("variant:change", (ev) => {
      console.group("🟡 variant:change");
      console.groupEnd();

      const { variant } = ev.detail || {};
      if (!variant) return;
      // 更新加入购物车按钮的变体ID
      changeCartAndBuyId(variant.id, []);

      const price = variant.price;
      const compare = variant.compare_at_price;

      DOM.originPrice = price;
      DOM.originComparePrice = compare;
      updatePriceDisplay();
      updateBottomBarColorByVariant(variant);
      updateVariantAvailable(variant.available);
      syncVariantCheckedState(variant);
    });
  }

  // 更新购物车按钮的变体ID
  function changeCartAndBuyId(id, bundleIds = []) {
    if (!id) return;
    const normalizedBundleIds = Array.isArray(bundleIds)
      ? bundleIds.filter(Boolean).map(String)
      : String(bundleIds || "")
        .split(",")
        .map((bundleId) => bundleId.trim())
        .filter(Boolean);
    const bundleIdsValue = normalizedBundleIds.join(",");
    const syncCartButton = (button) => {
      if (!button) return;
      button.setAttribute("data-id", id);
      if (bundleIdsValue) {
        button.setAttribute("data-bundle-ids", bundleIdsValue);
      } else {
        button.removeAttribute("data-bundle-ids");
      }
    };

    syncCartButton(DOM.addCartEl);
    syncCartButton(DOM.buyCartEl);
    syncCartButton(DOM.bottomAddCartEl);
    syncCartButton(DOM.bottomBuyNowEl);
  }

  // 加入购物车逻辑
  async function addOneToCart(variants) {
    if (!DOM.currentEl) return;

    // 显示加载状态
    DOM.currentEl.classList.add("loading");

    try {
      for (let i = 0; i < variants.length; i++) {
        const { id, quantity } = variants[i];
        if (!id || quantity <= 0) continue;

        // 发送添加到购物车请求
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ id, quantity }),
        });

        if (!response.ok) {
          throw new Error(`添加产品 ${id} 失败: ${response.statusText}`);
        }

        await response.json();

        if (i < variants.length - 1) {
          await new Promise((resolve) => setTimeout(resolve, 200));
        }
      }
      const cartRes = await fetch("/cart.js");
      const cart = await cartRes.json();
      if (window.updateStepCartGift) {
        await window.updateStepCartGift(cart);
      }
      if (cart && window && typeof window.updateMemberFirstOrderGift === 'function') {
        try {
          await window.updateMemberFirstOrderGift(cart);
        } catch (e) {
          console.error('处理会员首赠时出错:', e);
        }
      }
      if (cart && window && typeof window.updateFirstNOrdersGift === 'function') {
        try {
          // await window.updateFirstNOrdersGift(cart);
        } catch (e) {
          console.error('处理前N单赠品时出错:', e);
        }
      }
      const type = DOM.currentType;
      if (type === "checkout") {
        window.location.href = "/checkout";
      } else {
        // 触发购物车抽屉
        const cartDrawerBtn = document.querySelector(
          ".js-drawer-open-button-right"
        );
        if (cartDrawerBtn) cartDrawerBtn.click();
      }
    } catch (error) {
      console.error("添加到购物车失败:", error);
      alert(`添加产品失败: ${error.message}`);
    } finally {
      // 无论成功失败都移除加载状态
      DOM.currentEl.classList.remove("loading");
    }
  }

  // 绑定加入购物车按钮事件
  function bindCartEvent() {
    if (!DOM.addCartEl && !DOM.buyCartEl) return;
    if (DOM.addCartEl) {
      DOM.addCartEl.addEventListener("click", () => {
        changeCurrentInfo(DOM.addCartEl, "cart");
        bindQtyCartEvent();
      });
    }

    if (DOM.buyCartEl) {
      DOM.buyCartEl.addEventListener("click", () => {
        changeCurrentInfo(DOM.buyCartEl, "checkout");
        bindQtyCartEvent();
      });
    }
  }
  function changeCurrentInfo(el, type) {
    DOM.currentEl = el;
    DOM.currentType = type;
  }
  function bindQtyCartEvent() {
    console.group("🛒 bindQtyCartEvent");

    const qtyInput = productEl?.querySelector(
      "[data-product-form] .product-single__quantity .js-qty__num"
    );
    const productQty = qtyInput
      ? Math.max(1, parseInt(qtyInput.value) || 1)
      : 1;

    const sourceEl = DOM.currentEl || DOM.addCartEl;
    const bundleIds = (
      sourceEl?.getAttribute("data-bundle-ids") ||
      DOM.addCartEl?.getAttribute("data-bundle-ids") ||
      ""
    )
      .split(",")
      .map((id) => id.trim())
      .filter(Boolean);
    const baseId = sourceEl?.getAttribute("data-id") || DOM.addCartEl?.getAttribute("data-id");
    const baseItems = bundleIds.length
      ? bundleIds.map((id) => ({
        id,
        quantity: productQty,
      }))
      : [{
        id: baseId,
        quantity: productQty,
      }];

    const accessoryItems = [];
    document
      .querySelectorAll(".header-case-content .js-case-qty__num")
      .forEach((input) => {
        const qty = Math.max(0, parseInt(input.value) || 0);
        if (qty > 0) {
          accessoryItems.push({
            id: input.dataset.id,
            product_id: input.dataset.productId,
            quantity: qty,
          });
        }
      });

    const extendWarrantyItem = DOM.extendWarrantyVariantId
      ? {
          id: DOM.extendWarrantyVariantId,
          quantity: productQty,
        }
      : null;

    const allItems = extendWarrantyItem
      ? [...baseItems, ...accessoryItems, extendWarrantyItem]
      : [...baseItems, ...accessoryItems];
    if (allItems.length > 0) {
      console.groupEnd();

      addOneToCart(allItems);
    }
  }

  // 初始化所有功能
  function init() {
    console.group("🟢 INIT()");
    console.groupEnd();

    initBottomBarRefs(); // 先拿到底部条节点
    initProductBasePrice(); // 初始化 origin
    bindBundlePriceEvent();
    bindAccessoryPriceEvent();
    bindExtendWarrantyEvent();
    bindVariantPriceChangeFromTheme();
    bindCartEvent();
    bindBottomBarCartEvent();
    updatePriceDisplay(); // 主价/底部价首屏同步一次
  }

  init();
});
